import { useEffect } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import GalleryHero from "./components/GalleryHero";
import GalleryIntro from "./components/GalleryIntro";
import GalleryGrid from "./components/GalleryGrid";
import VideoGallery from "./components/VideoGallery";

export default function GalleryPage() {
  useEffect(() => {
    document.title =
      "Gallery | Project Photos & Villa Plot Developments | Urban Infra | UrbanInfraProjects.in";

    const setMeta = (name: string, content: string, prop = false) => {
      const selector = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let el = document.querySelector(selector) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        if (prop) el.setAttribute("property", name);
        else el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta(
      "description",
      "Browse the Urban Infra gallery — real project photos of 9+ premium villa plot developments, gated community layouts, and construction progress across Karnataka. UrbanInfraProjects.in."
    );
    setMeta("keywords", "Urban Infra gallery, villa plots photos Karnataka, gated community layouts photos, UrbanInfraProjects.in");
    setMeta("og:title", "Gallery | Villa Plot Project Photos | Urban Infra", true);
    setMeta("og:description", "Real project photos of 9+ premium villa plot developments and gated community layouts across Karnataka by Urban Infra.", true);
    setMeta("og:url", `${import.meta.env.VITE_SITE_URL ?? "https://www.urbaninfraprojects.in"}/gallery`, true);
    setMeta("og:site_name", "Urban Infra", true);
    setMeta("og:type", "website", true);

    // Schema.org JSON-LD — ImageGallery
    const schemaId = "schema-gallery";
    let script = document.getElementById(schemaId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = schemaId;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://www.urbaninfraprojects.in";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Gallery | Urban Infra",
      description:
        "Photo gallery of Urban Infra villa plots and residential layouts on Sarjapur Road, Bengaluru.",
      url: `${siteUrl}/gallery`,
      isPartOf: {
        "@type": "WebSite",
        name: "Urban Infra",
        url: siteUrl,
      },
    });

    window.scrollTo(0, 0);
    return () => {
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  return (
    <>
      <SiteHeader />
      <main>
        <GalleryHero />
      <GalleryIntro />
        <GalleryGrid />
        <VideoGallery />
      </main>
      <SiteFooter />
    </>
  );
}
